import React from 'react';

interface SkeletonProps {
  className?: string;
}

export default function Skeleton({ className = '' }: SkeletonProps) {
  return <div className={`animate-pulse bg-slate-200 rounded ${className}`} />;
}

export function StatCardSkeleton() {
  return (
    <div className="bg-white rounded-card shadow-card p-6">
      <Skeleton className="w-10 h-10 rounded-xl mb-4" />
      <Skeleton className="w-20 h-8 mb-2" />
      <Skeleton className="w-28 h-4" />
    </div>
  );
}

export function TableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="bg-white rounded-card shadow-card overflow-hidden">
      <div className="bg-surface px-5 py-3">
        <Skeleton className="w-full h-4" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="px-5 py-4 border-b border-border/50">
          <Skeleton className="w-full h-4" />
        </div>
      ))}
    </div>
  );
}
